const PREFIX = 'DONOR_LOOKUP';

export const API_URL = '/api_web/portal/moneyball/federal_contributions/lookup';

export const FETCH_DONORS = `${PREFIX}/FETCH_DONORS`;
export const RECEIVE_DONORS = `${PREFIX}/RECEIVE_DONORS`;
export const DONORS_NOT_FOUND = `${PREFIX}/DONORS_NOT_FOUND`;

export const DEFAULT_PER_PAGE = 5;
